import React, { Component } from 'react';
import budget from "../img/e-commerce.png";
import shophere from '../img/shophere.png';
import bov from '../img/bov screen.png';


class SectionOne extends Component {
    state = {  }
    render() { 
        return (  
            <div className="sectionOne" id="works">
                <h5> —PROJECTS</h5>
                <h2>Some Of the Projects I've Worked on🛠</h2>

                <div className="project_wrapper">

                    <div className="project_card">
                       
                        <div className="card_side card_side-front-a">
                            <div className="projects">
                                <div className="project_text">
                                    <h1 className="projectsHeader">Peace Shades<br/> (E-commerce Website)</h1>
                                </div>
                                <img src={budget} alt="" className="project_image"/>

                            </div>
                        </div>

                        <div className="card_side card_side-back-a">
                            <div className="back">
                                <button className="project_btn project_code">
                                    <a href="#">
                                        VIEW CODE   
                                    </a>
                                </button>

                                <button className="project_btn project_live">
                                    <a href="https://www.peaceshadescollections.com.ng/">
                                        VIEW LIVE   
                                    </a>
                                </button>
                            </div>

                        </div>

                    </div>

                    <div className="project_card">
                       
                        <div className="card_side card_side-front-b">
                            <div className="projects">
                                <div className="project_text">
                                    <h1 className="projectsHeader">SHOPHERE <br/> (Tour Web App)</h1>
                                </div>
                                <img src={shophere} alt="" className="project_image"/>
                            </div>
                       </div>

                       <div className="card_side card_side-back-b">
                            <button className="project_btn project_code">
                                <a href="https://github.com/dee-d-dev/BuyNow/tree/master">VIEW CODE</a>
                            </button>

                            <button className="project_btn project_live">
                                <a href="https://shophereguy.netlify.app/">VIEW LIVE</a>
                            </button>
                       </div>

                   </div>

                   <div className="project_card">
                       <div className="card_side card_side-front-c">
                            <div className="projects">
                                <div className="project_text">
                                    <h1 className="projectsHeader">BOV Photography <br/> (Photography Site)</h1>
                                </div>
                                <img src={bov} alt="" className="project_image"/>
                            </div>
                        </div>

                       <div className="card_side card_side-back-c">
                            <button className="project_btn project_code">
                                <a href="https://github.com/dee-d-dev/BOVphotography">VIEW CODE</a>
                            </button>

                            <button className="project_btn project_live">
                                <a href="https://bovphotography.netlify.app/">VIEW LIVE</a>
                            </button>
                       </div>
                   </div>

                </div>

                <div className="tab_project">
                    <div className="tab_project_card">
                         
                        <a href="https://www.peaceshadescollections.com.ng/">
                            <img src={budget} alt="project" className="tab_project_image"/>
                        </a>

                        <div className="tab-text">

                            <div className="links">
                                <div className="link">
                                    <div className="">
                                        <a href="#"><img src="https://img.icons8.com/ios-glyphs/30/000000/merge-git.png"/></a>
                                    </div>

                                    <div className="">
                                        <p>
                                            <a href="#">Code</a>
                                        </p>
                                    </div>
                                </div>

                                <div className="link">

                                    <div className="">
                                        <a href="https://www.peaceshadescollections.com.ng/">
                                            <img src="https://img.icons8.com/material-rounded/30/000000/visible.png" style={{marginRight: "15px"}}/>
                                        </a>
                                    </div>

                                    <div className="">
                                        <p>
                                            <a href="https://www.peaceshadescollections.com.ng/">Live</a> 
                                        </p>
                                    </div>
                                </div>
                            </div>

                        </div>
                    </div>

                        <div className="tab_project_card">
                         
                         <a href="https://shophereguy.netlify.app/">
                             <img src={shophere} alt="project" className="tab_project_image"/>
                         </a>
 
                         <div className="tab-text">
 
                            <div className="links">
                                <div className="link">
                                    <div className="">
                                        <a href="https://github.com/dee-d-dev/BuyNow/tree/master">
                                            <img src="https://img.icons8.com/ios-glyphs/30/000000/merge-git.png"/>
                                        </a>
                                    </div>
 
                                    <div className="">
                                        <p>
                                            <a href="https://github.com/dee-d-dev/BuyNow/tree/master">
                                                Code
                                            </a>
                                        </p>    
                                    </div>
                                </div>
 
                                <div className="link">
 
                                    <div className="">
                                        <a href="https://shophereguy.netlify.app/">
                                            <img src="https://img.icons8.com/material-rounded/30/000000/visible.png" style={{marginRight: "15px"}}/>
                                        </a>  
                                    </div>
 
                                    <div className="">
                                        <a href="https://shophereguy.netlify.app/">
                                            <p>Live</p>
                                        </a>
                                    </div>
                                </div>
                            </div>
 
                         </div>
                     </div>

                     <div className="tab_project_card">
                         
                         <a href="https://github.com/dee-d-dev/Natour-landing-page-project">
                             <img src={bov} alt="project" className="tab_project_image"/>
                         </a>
 
                         <div className="tab-text">
 
                             <div className="links">
                                 <div className="link">
                                     <div className="">
                                        <a href="https://github.com/dee-d-dev/BOVphotography">
                                            <img src="https://img.icons8.com/ios-glyphs/30/000000/merge-git.png"/>
                                        </a>
                                     </div>
 
                                     <div className="">
                                        <a href="https://github.com/dee-d-dev/BOVphotography">
                                         <p>Code</p>
                                        </a>
                                     </div>
                                 </div>
 
                                 <div className="link">
 
                                     <div className="">
                                        <a href="https://bovphotography.netlify.app/">
                                            <img src="https://img.icons8.com/material-rounded/30/000000/visible.png" style={{marginRight: "15px"}}/>
                                        </a>
 
                                     </div>
 
                                     <div className="">
                                        <a href="https://bovphotography.netlify.app/">
                                            <p>Live</p>
                                        </a>
                                     </div>
                                 </div>
                             </div>
 
                         </div>
                     </div>
                </div>
            </div>
        );
    }
}
 
export default SectionOne;